import React from 'react';
import DNS from '../dns/DNS';

const SingleDNSContainer = () => {
  let instance_id = location?.hash?.split('instance/')[1];
  return <DNS instance_id={instance_id} />;
};
export default SingleDNSContainer;
